<template>
	<div>
		<b-modal id="modalDamageView" hide-footer hide-header  @close="close" no-close-on-backdrop no-close-on-esc size="lg">
			<div class="fullscreen" v-if="show">
				
				
				<div class="damage-box">
					
					<div class="images">
						
						<VueSlickCarousel 
							v-if="damage.images.length>0"
							ref="carSwiper" 
							:slidesToShow="1" 
							:slidesToScroll="1"
							:arrows="false" 
							:dots="false"
							:adaptiveHeight="true"
							class="">
							<div v-for="image in damage.images" :key="image.id">
								<div class="image">
									<img :src="API_URL+image.url" class="img-fluid">
								</div>
							</div>
						</VueSlickCarousel>
					</div>
					
					<div class="data">

						<div class="btn btn-close icon icon-close" @click="close"></div>
						<h5>DETALLE DEL DAÑO</h5>
						<div class="mt-4">
							<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+car.category.draw+'/'+damage.side+'.png') }')` }" >
								<div >
									<div class="point animated bounceIn"
										:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
										:class="[damage.type.toLowerCase()]"
									>
									</div>
								</div>
							</div>

						</div>
						
						<div class="p-3">
							<label class="label">{{damage.typeText}}</label>
							<p>
								{{damage.description}}
							</p>
						</div>
						<div class="p-3">
							
							<div class="btn btn-success btn-block" v-if="damage.status==1" >REPARADO</div>
						</div>
					</div>

				</div>

				
			</div>
		</b-modal>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
	name: "DamageView",
	components:{
		VueSlickCarousel,
	},
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			show: false,
			damage: {
				images:[]
			},
			car: null,
		}
	},
	methods:{
		open (damage, car) {
			this.damage = damage
			this.car = car
			this.show = true
			this.$bvModal.show('modalDamageView')
		},
		close () {
			this.show=false
			this.damage = null
			this.car = null
			this.$bvModal.hide('modalDamageView')
		},
		
		changed(){
			this.$emit('changed')
			this.close()
		}
	}

}
</script>

<style lang="scss" scoped>

.damage-box{
	display: flex;
	width: 100%;
	height: 100%;

	.images{
		flex-grow: 1;
		background-color: #f1f1f1;
		max-width: calc(100% - 270px);
		max-height: 100%;
		position: relative;

		.image{
			width:100%;
			height:100vh;
			padding: 15%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.data{
		width: 270px;
		height: 100%;
		flex-grow: 0;
		flex-shrink: 0;
		background-color: #fff;

		h5{
			margin: 6px 12px;
		}
		.btn-close{
			position: absolute;
			top: 4px;
			right: 4px;
		}
	}
}

// .slick-slide{
// 	width:90%;
// 	height:90%;
// }
.slick-list, .slick-track{
	height: 100vh !important;
}


</style>